import React, { useEffect, useState } from "react";
import useAxios from "axios-hooks";
import {
    DefaultButton,
    Dialog,
    DialogFooter,
    DialogType,
    PrimaryButton,
    TextField,
} from "@fluentui/react";
import { useHistory, useRouteMatch } from "react-router-dom";

const CloneCourseModal = ({
    showModal,
    toggleShowModal,
    courseId,
}) => {
    const history = useHistory();
    let { url } = useRouteMatch();

    const [title, setTitle] = useState("");
    const [slug, setSlug] = useState("");

    const [{ loading }, executeClone] = useAxios(
        {
            method: "post",
            url: `/courses/${courseId}/clone`,
        },
        { manual: true }
    );

    return (
        <Dialog
            hidden={!showModal}
            onDismiss={toggleShowModal}
            modalProps={{
                isBlocking: true,
            }}
            dialogContentProps={{
                type: DialogType.normal,
                title: "Warning",
                subText: "Please enter a new slug for the cloned course",
            }}
        >
            <TextField
                label="Enter the new title for this course"
                onChange={(e, newValue) => {
                    setTitle(newValue);
                    setSlug(formatStringAsSlug(newValue))
                }}
                value={title}
            />
            <TextField
                label="Enter the new slug for this course"
                onChange={(e, newValue) => setSlug(newValue)}
                value={slug}
            />
            <DialogFooter>
                <PrimaryButton
                    loading={loading}
                    onClick={async () => {
                        var result = await executeClone({ data: { slug, title } });

                        if (!result.isAxiosError) {
                            history.push(`${url}/${result.data.crsid}/${result.data.revNum}/wizard`)
                            toggleShowModal();
                        }
                    }}
                    text="Clone"
                />
                <DefaultButton
                    onClick={toggleShowModal}
                    text="Cancel"
                />
            </DialogFooter>
        </Dialog>
    );
};

function formatStringAsSlug(string) {
    return string && string.toLowerCase().split(" ").join("-");
}

export default CloneCourseModal;
